<div class="icon-container">
  <ng-container [ngSwitch]="type">
    <mat-icon class="material-icons-outlined" *ngSwitchCase="'info'">info_i</mat-icon>
    <mat-icon class="material-icons-outlined" *ngSwitchCase="'warning'">warning_amber</mat-icon>
    <mat-icon class="material-icons-outlined" *ngSwitchCase="'error'">error_outline</mat-icon>
  </ng-container>
</div>
<div class="content-container">
  <div class="text-container">
    <ng-content select="[message]"></ng-content>
    <div class="time-container ml">{{ notification.payload.attributes.created_at | timeago:true }}</div>
  </div>
  <div class="actions-container">
    <ng-content select="[action]"></ng-content>
  </div>
</div>
<div class="close-container">
  <mat-icon class="close-icon cursor mat-icon material-icons-outlined color-grey-light color-black-hover" (click)="markAsRead()">cancel</mat-icon>
</div>
<div class="loader" *ngIf="loading$ | async">
  <mat-progress-spinner mode="indeterminate" diameter="20"></mat-progress-spinner>
</div>
